import React from "react";
import { FaTiktok } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="Footer">
      <div className="Footer_Top">
        <div className="Footer_Info">
          <div>
            <h4>Location</h4>
            <p>
              Kivora Studio<br />
              Budapest, Hungary
            </p>
          </div>

          <div>
            <h4>Contact Us</h4>
            <p>Email: kivora.co@gmail.com</p>
            <p>Customer Service Hours: Mon–Fri, 9 AM – 6 PM</p>
          </div>
        </div>

        {/* <div className="Footer_Newsletter">
          <h4>Sign up for our newsletter</h4>
          <div className="Footer_NewsletterForm">
            <input type="email" placeholder="Enter email address" />
            <button>Enter</button>
          </div>
        </div> */}
      </div>

      <div className="Footer_Bottom">
        <div className="Footer_Socials">
          {/* <a href="/"><FaTwitter /></a>
          <a href="/"><FaTelegramPlane /></a>
          <a href="/"><FaFacebookF /></a>
          <a href="/"><FaInstagram /></a> */}
          <a href="https://www.tiktok.com/@kivora.co"><FaTiktok/></a>
        </div>

        <p>© {new Date().getFullYear()} Kivora Ceramics. All Rights Reserved</p>

        <a href="/" className="Footer_Terms">
          Terms & Conditions
        </a>
      </div>
    </footer>
  );
};

export default Footer;
